import Vue from "vue";
import Vuex from "vuex";

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import { Auth, Hub } from "aws-amplify";

console.log(process.env.VUE_APP_IDENTITY_POOL_ID);
Amplify.configure({
  Auth: {
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID
  }
  // Storage: {
  //   AWSS3: {
  //     bucket: process.env.VUE_APP_AWS_S3_BUCKET, //REQUIRED -  Amazon S3 bucket name
  //     region: process.env.VUE_APP_REGION //OPTIONAL -  Amazon service region
  //   }
  // },
  // oauth: {
  //   domain: "your_cognito_domain",
  //   scope: [
  //     "phone",
  //     "email",-->
  //     "profile",
  //     "openid",
  //     "aws.cognito.signin.user.admin"
  //   ],
  //   redirectSignIn: "http://localhost:8080/SignIn",
  //   redirectSignOut: "http://localhost:8080/SignOut",
  //   responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  // }
  // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
  // mandatorySignIn: false,

  // OPTIONAL - Configuration for cookie storage
  // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
  // cookieStorage: {
  //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
  //   domain: ".onseminar.com",
  //   // OPTIONAL - Cookie path
  //   // path: "/",
  //   // OPTIONAL - Cookie expiration in days
  //   // expires: 365,
  //   // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
  //   sameSite: "lax",
  //   // OPTIONAL - Cookie secure flag
  //   // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
  //   secure: true
  // }

  // OPTIONAL - customized storage object
  // storage: MyStorage,

  // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
  // authenticationFlowType: "USER_SRP_AUTH",

  // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
  // clientMetadata: { myCustomKey: "myCustomValue" },

  // OPTIONAL - Hosted UI configuration
});

Vue.use(AmplifyPlugin, AmplifyModules);

const listener = data => {
  switch (data.payload.event) {
    case "signIn":
      console.log("[Aws-amplify/EVENT] #signIn");
      break;
    case "signUp":
      console.log("[Aws-amplify/EVENT]  #signUp");
      break;
    case "signOut":
      console.log("[Aws-amplify/EVENT]  #signOut");
      break;
    case "signIn_failure":
      console.log("[Aws-amplify/EVENT]  #user sign in failed");
      break;
    case "configured":
      console.log("#[Aws-amplify/EVENT] #the Auth module is configured");
  }
};

Hub.listen("auth", listener);

// You can get the current config object
// const currentConfig = Auth.configure();
Vue.prototype.$Auth = Auth;
// Vue.prototype.$Storage = Storage;
Vuex.Store.prototype.$Auth = Auth;

export default Auth;
